import { getSuffixIsImageType, getSuffixIsDocType } from './util.js';
export default {
    configuration: true,
    selection: true,
    table: {
        clickModify: true,
        selectBtn: true,
        leftOperation: true,
        leftWidth: 60,
        height: 350,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 150,
                amendState: true
            },
            {
                label: '名称',
                prop: 'name',
                sort: true,
                width: 150
            },
            {
                label: '附件类型',
                prop: 'type',
                sort: true,
                width: 150
            },
            {
                label: '大小',
                prop: 'fileSize',
                sort: true,
                width: 150
            },
            {
                label: '类型',
                prop: 'objTypeName',
                sort: true,
                width: 182
            },
            {
                label: '创建人',
                sort: true,
                prop: 'createUserName',
                width: 120
            },
            {
                label: '创建时间',
                sort: true,
                prop: 'createTime',
                width: 120
            },
            {
                label: '更新人',
                sort: true,
                prop: 'updateUserName',
                width: 120
            },
            {
                label: '更新时间',
                sort: true,
                prop: 'updateTime',
                width: 120
            }
        ],
        action: {
            fixedWidth: 140,
            list: [
                {
                    type: 'text',
                    label: '查看影像',
                    size: 'mini',
                    event: 'viewImg',
                    displayRule: row => {
                        return getSuffixIsImageType(row.type);
                    }
                },
                {
                    type: 'text',
                    label: '删除附件',
                    size: 'mini',
                    event: 'delete',
                    displayRule: row => {
                        // 到车标识为待处理
                        return row.registrationStatus === '0';
                    }
                },
                {
                    type: 'text',
                    label: '下载附件',
                    size: 'mini',
                    event: 'dowload',
                    displayRule: row => {
                        return getSuffixIsDocType(row.type);
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: ''
    }
};
